export class LineItem {
  Amount: number;
  AmountLocal: number;
  CanBeEachWay?: boolean;
  downOdd: boolean;
  EventDate: string;
  EventHasHandicap: boolean;
  EventId: string;
  EventName: string;
  GameBetTypeAvailability: number;
  GameId: string;
  GameLocked: boolean;
  GameName: string;
  GameSpecialOddsValue: string;
  IsLive: boolean;
  ItemId?: number;
  LeagueId?: string;
  LineErrorMessages: string[];
  LineErrors: any;
  LocationId?: any;
  Name: string;
  NodeId: string;
  NotAvailable: boolean;
  Odd: number;
  Place: number;
  ResultName: string;
  ResultsNr: string;
  Selected: boolean = false;
  SportHandle: string;
  TicketNumber: string;
  TotalPotentialWin?: number;
  upOdd: boolean;
  constructor() {
    this.LineErrorMessages = [];
    this.ItemId = null;
    this.NotAvailable = false;
  }

  static mapItem(item) {
    const lineItem = new LineItem();
    lineItem.Amount = 0;
    lineItem.AmountLocal = 0;
    lineItem.CanBeEachWay = item.CanBeEachWay || false;
    lineItem.downOdd = item.downOdd;
    lineItem.EventDate = item.EventDate;
    lineItem.EventId = item.EventId;
    lineItem.EventName = item.EventName;
    lineItem.EventHasHandicap = item.EventHasHandicap || false;
    lineItem.GameId = item.GameId;
    lineItem.GameLocked = item.GameLocked || false;
    lineItem.GameName = item.GameName;
    lineItem.GameSpecialOddsValue = item.GameSpecialOddsValue;
    lineItem.GameBetTypeAvailability = item.GameBetTypeAvailability || 0;
    lineItem.IsLive = item.IsLive || false;
    lineItem.ItemId = item.ItemId;
    lineItem.LeagueId = item.Parent3NodeId;
    lineItem.LocationId = item.Parent4NodeId;
    lineItem.Name = item.Name ? item.Name : item.ResultName;
    lineItem.NodeId = item.NodeId;
    lineItem.NotAvailable = false;
    lineItem.Odd = item.Odd;
    lineItem.Place = item.Place || 0;
    lineItem.ResultName = item.Name ? item.Name : item.ResultName;
    lineItem.ResultsNr = item.NodeId;
    lineItem.Selected = false;
    lineItem.SportHandle = item.SportHandle;
    lineItem.TicketNumber = "";
    lineItem.TotalPotentialWin = 0;
    lineItem.upOdd = item.upOdd;
    return lineItem;
  }

  static mapItemFromIdService(item) {
    const lineItem = {
      Amount: 0,
      AmountLocal: 0,
      CanBeEachWay: item.CanBeEachWay || false,
      downOdd: false,
      EventDate: item.EventDate,
      EventHasHandicap: item.EventHasHandicap || false,
      EventId: item.Parent2NodeId,
      EventName: item.Parent2NodeName,
      GameBetTypeAvailability: item.GameBetTypeAvailability || 0,
      GameId: item.ParentNodeId,
      GameName: item.ParentNodeName,
      GameSpecialOddsValue: item.GameSpecialOddsValue || "",
      GameTypeId: item.GameId,
      IsLive: item.IsLive,
      ItemId: item.ItemId,
      LeagueId: item.Parent3NodeId,
      LocationId: item.Parent4NodeId,
      Name: item.Name ? item.Name : item.ResultName,
      NodeId: item.NodeId,
      NotAvailable: false,
      NumberOfStarters: null,
      Odd: item.Odd,
      Place: item.Place || 0,
      ResultName: item.NodeName,
      ResultsNr: item.NodeId,
      Selected: false,
      SportHandle: item.SportHandle,
      TicketNumber: "",
      SportId: item.SportId,
      TotalPotentialWin: 0,
      upOdd: false,
    };
    return lineItem;
  }

  static mapItemFromIdServiceV2(item) {
    const lineItem = {
      Amount: 0,
      AmountLocal: 0,
      CanBeEachWay: item.CanBeEachWay || false,
      downOdd: item.downOdd,
      EventDate: item.EventDate,
      EventHasHandicap: item.EventHasHandicap || false,
      EventId: item.EventId,
      EventName: item.EventName,
      GameBetTypeAvailability: item.GameBetTypeAvailability || 0,
      GameId: item.GameId,
      GameName: item.GameName,
      GameSpecialOddsValue: item.GameSpecialOddsValue || "",
      GameTypeId: item.GameTypeId,
      IsLive: item.IsLive,
      ItemId: item.ItemId,
      LeagueId: item.LeagueId,
      LocationId: item.LocationId,
      Name: item.ResultName,
      NodeId: item.ResultsNr,
      NotAvailable: false,
      NumberOfStarters: 0,
      Odd: item.Odd,
      Place: item.Place || 0,
      ResultName: item.ResultName,
      ResultsNr: item.ResultsNr,
      Selected: false,
      SportHandle: item.SportHandle,
      TicketNumber: "",
      SportId: item.SportId,
      TotalPotentialWin: item.TotalPotentialWin,
      upOdd: item.upOdd,
    };
    return lineItem;
  }
}
